export default function RequiredIcon() {
  return <span style={{ color: "#ce4a4a" }}>*</span>;
}
